export default __webpack_public_path__ + "static/media/auth-bg.ef5e53cf.png";